import { Type } from "class-transformer";
import { OrderItemStateV2 } from "./order-item-state-v2";
import { OrderItemMiscStateV2 } from "./order-item-misc-state-v2";
import { OrderStatus } from '../order-status';
import { ComponentReferencesV2 } from "./component-references-v2";

export class OrderStateV2 {
    public Id: number;
    public Uuid: string;
    public AxId: number;
    @Type(() => Date)
    public CreatedAt: Date;
    @Type(() => Date)
    public CompletedDate: Date;

    @Type(() => ComponentReferencesV2)
    public ComponentReferences: ComponentReferencesV2 = new ComponentReferencesV2();

    @Type(() => OrderItemStateV2)
    public OrderItems: Array<OrderItemStateV2>;

    @Type(() => OrderItemMiscStateV2)
    public OrderItemMiscs: Array<OrderItemMiscStateV2>;

    public Status: OrderStatus;

    public CustomerNo: string;
    public CustomerName: string;
    public CustomerEmail: string;
    public CheckedOrderConfirmationEmailAddressesString: string;
    public Alias: string;

    public Address: string;
    public FullAddress: string;
    public ShipToId: number;

    public TestOrder: boolean;
    public AllowPartialShipment: boolean;
    public NoVisit: boolean;

    public Notes: string;
    public NotesCustomerService: string;
    public PaymentTerms: string;
    public CrmTicketId: string;
    public Caution: string;
    public Signature: string;
    public ShopInfos: string;

    @Type(() => Date)
    public EarliestDeliveryDate: Date;

    @Type(() => Date)
    public VisitDate: Date;

    public FairId: string;
    public FairName: string;

    public ConsultantUuid: string;
}

